export enum BadgeVariants {
  Default,
  SingularWhite,
}

const badgeVariants = {
    [BadgeVariants.Default]: "px-3.5 py-1 bg-white rounded-full",
    [BadgeVariants.SingularWhite]: "max-md:hidden absolute bg-white px-3.5 py-1 left-10 top-10 rounded-full border border-singular-dark-pink text-singular-dark-pink font-semibold uppercase text-[12px] tracking-widest",
};

export interface BadgeProps {
  label: string;
  variant: BadgeVariants;
  className?: string;
}

const Badge = ({ label, variant = BadgeVariants.Default, className = '' }: BadgeProps) => {
  return (
    <div className={`${badgeVariants[variant]} ${className}`}>
      {label}
    </div>
  );
};

export default Badge;
